export default "__VITE_ASSET__CZ7As9lJ__"